import { render, staticRenderFns } from "./GhostRating.vue?vue&type=template&id=04b8173c&scoped=true&"
import script from "./GhostRating.vue?vue&type=script&lang=js&"
export * from "./GhostRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8173c",
  null
  
)

export default component.exports